<template>
	<section class="other_page_banner banner_nxt_sec_not_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.business_global_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{ $t('new_ui.business_global_page.section_banner.main_title') }}
						</h2>
						<h6>
							{{ $t('new_ui.business_global_page.section_banner.sub_title') }}
						</h6>
						<p>
							{{
								$t('new_ui.business_global_page.section_banner.paragraph.one')
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-6 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image2" alt="" />
					</div>
				</div>
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image8" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.business_global_page.question_sec.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{ $t('new_ui.business_global_page.question_sec.title.one') }}
									<span
										>{{
											$t('new_ui.business_global_page.question_sec.title.two')
										}}
									</span>
									{{
										$t('new_ui.business_global_page.question_sec.title.three')
									}}
								</h4>
								<p>
									{{ $t('new_ui.business_global_page.question_sec.paragraph') }}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register"
										>{{
											$t(
												'new_ui.business_global_page.question_sec.cta_buttons.one',
											)
										}}
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="global_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="global_mid_inn">
						<span
							>{{ $t('new_ui.business_global_page.global_mid.label') }}
						</span>
						<h4>
							{{ $t('new_ui.business_global_page.global_mid.title.one') }}
							<span>{{
								$t('new_ui.business_global_page.global_mid.title.two')
							}}</span>
							{{ $t('new_ui.business_global_page.global_mid.title.three') }}
						</h4>
						<p>
							{{ $t('new_ui.business_global_page.global_mid.paragraph') }}
						</p>
						<div class="starting_to_btn">
							<a href="/auth/register">{{
								$t('new_ui.business_global_page.global_mid.cta_buttons.one')
							}}</a>
						</div>
						<div class="house_dia_image">
							<img :src="img.image3" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="online_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-6 d-block d-md-none">
							<div class="business_anywhere_rt">
								<img :src="img.image4" alt="" />
							</div>
						</div>
						<div class="col-sm-6">
							<div class="business_anywhere_lt">
								<span>{{
									$t('new_ui.business_global_page.online_mid.label')
								}}</span>
								<div class="business_anywhere_txt">
									<h4>
										{{ $t('new_ui.business_global_page.online_mid.title.one') }}
										<br /><span>{{
											$t('new_ui.business_global_page.online_mid.title.two')
										}}</span>
									</h4>
									<p>
										{{ $t('new_ui.business_global_page.online_mid.paragraph') }}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">{{
											$t(
												'new_ui.business_global_page.online_mid.cta_buttons.one',
											)
										}}</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6 d-none d-md-flex">
							<div class="business_anywhere_rt">
								<img :src="img.image4" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_global_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.business_global_page.section_newsletter.title.one')
								}}</span>
								{{
									$t('new_ui.business_global_page.section_newsletter.title.two')
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_global_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_global_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_global_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_global_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import globalban from '@/assets/images/sub/global_ban.png';
import exchdia from '@/assets/images/sub/exchng_diagram.png';
import housedia from '@/assets/images/sub/house_illus.png';
import g1 from '@/assets/images/sub/g1.png';
import acctmobdia from '@/assets/images/sub/acct_mob_dia.png';

export default {
	data: () => {
		return {
			img: {
				image1: globalban,
				image2: exchdia,
				image3: housedia,
				image4: g1,
				image8: acctmobdia,
			},
		};
	},
};
</script>
